import React from "react";
import "./apartemen1.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import MtownRimages from "./Mtownresidence.js";
import Rainbowimages from "./Rainbow.js";
import MtownSimages from "./Mtownsignature.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faArrowsUpDownLeftRight,
  faMedal,
} from "@fortawesome/free-solid-svg-icons";

import {faBed} from "@fortawesome/free-solid-svg-icons";
import {faShower} from "@fortawesome/free-solid-svg-icons";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const Produk1 = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const whatsappMtownResidence = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Apartemen%20M-Town%20Residence%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const whatsappMtownSignature = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Apartemen%20M-Town%20Signature%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const whatsappRainbow = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Apartemen%20Rainbow%20Springs%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="container">
      <div className="containercard-apart">
        <div className="card">
          <Slider {...settings}>
            {MtownRimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">M-Town Residence</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Siap Huni, Free PPN</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 45m²</span>
            <FontAwesomeIcon color="#334442" icon={faBed} />
            <span> 2</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 1</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">3 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button
              onClick={whatsappMtownResidence}
              className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {MtownSimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">M-Town Signature</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Siap Huni, Free PPN</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 91m²</span>
            <FontAwesomeIcon color="#334442" icon={faBed} />
            <span> 3</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 2</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">9 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button
              onClick={whatsappMtownSignature}
              className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Rainbowimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Rainbow Spring</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Siap Huni</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 125m²</span>
            <FontAwesomeIcon color="#334442" icon={faBed} />
            <span> 4+1</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 2</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">8 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={whatsappRainbow} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Produk1;
